import { z } from 'zod';
import { CONTENT_CONSTRAINTS } from '@/lib/constants/appContent';

export const listlistFormSchema = z.object({
  title: z
    .string()
    .min(CONTENT_CONSTRAINTS.TITLE_MIN, 'Title is required')
    .max(CONTENT_CONSTRAINTS.TITLE_MAX, `Title must be ${CONTENT_CONSTRAINTS.TITLE_MAX} characters or less`),
  descShort: z
    .string()
    .max(CONTENT_CONSTRAINTS.DESC_SHORT_MAX, `Description must be ${CONTENT_CONSTRAINTS.DESC_SHORT_MAX} characters or less`),
  mediaStateTypeId: z.number(),
});

export type ListlistFormSchemaData = z.infer<typeof listlistFormSchema>;
